import React from 'react';
import Sidebar from '../../components/common/Sidebar';
import Navbar from '../../components/common/Navbar';
import GatePassForm from '../components/forms/GatePassForm';
import '../../wrms/css/wrms.css';

const GatePassPage = () => (
  <div className="d-flex wrms-page">
    <Sidebar />
    <div className="flex-grow-1">
      <Navbar />
      <div className="wrms-container">
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="wrms-page-header">
            <div className="wrms-breadcrumb">Requests · <span>Gate Pass</span></div>
            <h1 className="wrms-page-title">Request Gate Pass</h1>
            <p className="wrms-page-subtitle">Submit a gate pass for temporary exit during working hours.</p>
          </div>
          <div className="wrms-card" style={{ overflow: 'hidden' }}>
            <GatePassForm />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default GatePassPage;
